/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../styles/partials/project-credit.module.scss';

const propTypes = {
    title: PropTypes.string,
    people: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
        }),
    ),
    className: PropTypes.string,
};

const defaultProps = {
    title: null,
    people: [],
    className: null,
};

const ProjectCredit = ({ title, people, className }) => {
    const peopleCount = (people || []).length;
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <h4 className={styles.title}>{title !== null ? title : null}</h4>
            {(people || []).map(({ name = null }, personIndex) => (
                <div key={`person-${personIndex + 1}`} className={styles.name}>
                    {name !== null ? name : null}
                    {personIndex < peopleCount - 1 ? ',' : ''}
                    &nbsp;
                </div>
            ))}
        </div>
    );
};

ProjectCredit.propTypes = propTypes;
ProjectCredit.defaultProps = defaultProps;

export default ProjectCredit;
